import jsPDF from "jspdf";
import moment from "moment";
import certificateImage from "../../assets/img/course_completion_certificate.jpg";

export const generateCertificate2 = (programData, userInfo) => {
    const doc = new jsPDF({
        orientation: "landscape",
        filters: ["ASCIIHexEncode"],
    });
    doc.addImage(certificateImage, "JPEG", 0, 0, 298, 213, undefined, "FAST");
    doc.setTextColor("#B68646");
    let pageWidth = doc.internal.pageSize.getWidth();
    doc.setFont;
    doc.text(
        pageWidth / 2 -
        (userInfo.course.courseOwner
            ? userInfo.course.courseOwner.trainingCenterName
                ? (doc.getTextWidth(userInfo.course.courseOwner.trainingCenterName) /
                2) + 13
                : 0
            : 0),
        68,
        `${
            userInfo.course.courseOwner
                ? userInfo.course.courseOwner.trainingCenterName
                    ? userInfo.course.courseOwner.trainingCenterName.toUpperCase()
                    : "-"
                : "-"
        }`
    );
    doc.setTextColor("black");
    doc.setFontSize(15);
    userInfo.trainee ?
        (doc.text(
            120,
            102,
            `${userInfo.trainee.firstName ? userInfo.trainee.firstName : "-"} ${userInfo
                .trainee.middleName && userInfo.trainee.middleName} ${userInfo.trainee
                .lastName && userInfo.trainee.lastName}`
        )) : (doc.text(
            120,
            102,
            `${userInfo.person.firstname ? userInfo.person.firstname : "-"} ${userInfo
                .person.middlename && userInfo.person.middlename} ${userInfo.person
                .lastname && userInfo.person.lastname}`
        ))
    doc.text(
        (pageWidth / 2) - (programData.courseTitleCat2 ? (doc.getTextWidth(programData.courseTitleCat2) / 2) : 0),
        122,
        `${
            programData.courseTitleCat2
                ? programData.courseTitleCat2
                : "-"
        }`
    );
    doc.setFontSize(12);
    doc.text(
        80,
        135,
        `${
            "-"
        }`
    );
    doc.text(
        67,
        143,
        `${
            programData.ceu
                ? programData.ceu
                : "-"
        }`
    );
    doc.text(
        67,
        151,
        `${moment(programData.courseCompletionDate).format("MMM DD, YYYY")}`
    );

//   doc.text(
//     188,
//     135,
//     `${
//       programData.course.courseAccreditor
//         ? programData.course.courseAccreditor.accreditorName
//           ? programData.course.courseAccreditor.accreditorName
//           : "-"
//         : "-"
//     }`
//   );
    window.open(doc.output("bloburl"));
};
